import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import {
  ContentHeader,
  ContentTitle,
} from 'components/Content'
import Content from '../Content'
import ElementContentIcon from '../ContentIcon'
import LinkContainer from 'components/LinkContainer'
import styled from 'styled-components'
import { useCardContext } from 'dataProviders/Card'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'components/Intl'

const ContentTitleLabel = styled(ContentTitle)`
  flex: 0 0 auto;
  margin-right: 1em;
`

const ContentTitleValue = styled(ContentTitle)`
  flex: 0 1 auto;
  margin-left: auto;
  margin-right: 1em;
  font-weight: normal !important;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Board = () => {
  const cardContext = useCardContext()

  const boardId = useSelector<any, number>(state => state['view-board'].cards[cardContext.id].boardId)

  const boardName = useSelector<any, string>(state => state['view-board'].view[state['view-board'].cards[cardContext.id].boardId].name)

  return (
    <Content>
      <LinkContainer
        to={'/board/' + boardId}
      >
        <ContentHeader>
          <ElementContentIcon>
            <KanBoIcon name='kanbo-24-board' />
          </ElementContentIcon>
          <ContentTitleLabel>
            <FormattedMessage id='BOARD' />
          </ContentTitleLabel>
          <ContentTitleValue>
            {boardName}
          </ContentTitleValue>
        </ContentHeader>
      </LinkContainer>
    </Content>
  )
}

export default Board